import { render, staticRenderFns } from "./CursorAwayIcon.vue?vue&type=template&id=4c1342d4&"
import script from "./CursorAwayIcon.vue?vue&type=script&lang=js&"
export * from "./CursorAwayIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports